import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import dataServices from "../../apiServices/data.services";
import Loader from "../../components/Loader/Loader";
import { useAlert } from "react-alert";
import { handleValidationError } from "../../components/CommonFunctions";

const PaymentDetails = () => {
  const { id } = useParams();
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const alert = useAlert();

  useEffect(() => {
    dataServices
      .getPaymentDetails(id)
      .then((res) => {
        if (res.status === 200) {
          setPayment(res.data);
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      })
      .finally(() => setLoading(false));
  }, [id, alert]);

  if (loading) return <Loader />;
  if (!payment)
    return (
      <div className="content-wrapper">
        <p className="px-3">Payment not found.</p>
      </div>
    );

  return (
    <div className="content-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-2 pb-1 fw-bold text-black">Payment Details</h6>
        <button className="btn btn-sm btn-secondary" onClick={() => navigate("/payments")}>Back</button>
      </div>
      <div className="card p-3">
        <p><strong>ID:</strong> {payment.id}</p>
        <p><strong>Subscription:</strong> {payment.subscription?.id || payment.subscription_id || "N/A"}</p>
        <p><strong>Amount:</strong> ₹{payment.amount}</p>
        <p><strong>Payment Date:</strong> {payment.payment_date}</p>
        <p><strong>Status:</strong> {payment.status}</p>
        <p><strong>Transaction ID:</strong> {payment.transaction_id || "N/A"}</p>
        <p><strong>Discount Amount:</strong> {payment.discount_amount || "0"}</p>
        <p><strong>Description:</strong> {payment.description || "N/A"}</p>
      </div>
    </div>
  );
};

export default PaymentDetails;
